"use client"

import styled from "@emotion/styled"
import { Button, Typography } from "@mui/material"
import { useInView } from "react-intersection-observer"
import "swiper/css"
import { Desktop, Mobile, transitionTime, useInViewConfig } from "ui"
import Container from "ui/Container"
import { delayTime, transitionEase } from "ui/transitions/utils"
import { extractProperty, getNonUmbracoUrl, HistoryData, Link } from "utils"
import HistorySwiper from "./HistorySwiper"
import HistoryTimeLine from "./TimeLine"

const OuterLayout = styled.div`
  width: 100%;
  padding: 64px 16px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    padding: 88px 0;
  }
  display: flex;
  flex-direction: column;
  gap: 64px;
`

const StyledTypography = styled(Typography, {
  shouldForwardProp: (prop: string) => prop !== "$inView",
})<{ $inView: boolean }>`
  margin: auto;
  opacity: ${(p) => (p.$inView ? 1 : 0)};
  transition: all ${transitionTime}s ${transitionEase};
  transform: ${(p) => (p.$inView ? "translateX(0px)" : `translateX(-100vw)`)};
  transition-delay: ${delayTime}s;
`

const StyledButton = styled(Button)`
  ${({ theme }) => theme.breakpoints.down("md")} {
    width: 100%;
  }
`

type UndStr = string | undefined

export default function History({
  data,
  historyData,
  locale,
}: {
  data: any
  historyData: HistoryData[]
  locale: string
}) {
  const title = extractProperty(data, "title") as UndStr
  const button = extractProperty(data, "button")
  const selectItems =
    (extractProperty(data, "selectItemToShow") as {
      url: string
      name: string
    }[]) || []
  const buttonText = button?.[0]?.name as UndStr
  const buttonLink = button?.[0]?.url as UndStr
  const filteredHistoryData = historyData.filter((el) => {
    if (selectItems.length === 0) return true
    return selectItems.some((item) => item.url === el.url)
  })
  const { ref, inView } = useInView(useInViewConfig)
  return (
    <>
      {historyData?.length > 4 ? (
        <OuterLayout ref={ref}>
          <Container>
            <Desktop>
              <StyledTypography variant="h2" $inView={inView}>
                {title}
              </StyledTypography>
            </Desktop>
            <Mobile>
              <StyledTypography variant="h2" $inView={inView}>
                {title}
              </StyledTypography>
            </Mobile>
          </Container>

          <HistorySwiper
            data={filteredHistoryData}
            inView={inView}
            locale={locale}
          />
          <HistoryTimeLine data={filteredHistoryData} inView={inView} />
          <Container>
            <StyledButton
              variant="primary"
              style={{ margin: "auto" }}
              LinkComponent={Link}
              href={getNonUmbracoUrl(buttonLink)}
            >
              {buttonText}
            </StyledButton>
          </Container>
        </OuterLayout>
      ) : (
        <></>
      )}
    </>
  )
}
